import React from "react";
import { Link } from "react-router-dom";
import { LegalPage, Part, List, Mail, Phone, COMPANY } from "@/components/Legal";

// Public data-deletion instructions (dentmemo.in/data-deletion). Meta and Google app reviews ask for a
// public URL like this, so keep it stable. Update UPDATED whenever the text changes.

const UPDATED = "3 November 2026";

export default function DataDeletion() {
  return (
    <LegalPage title="Data Deletion" updated={UPDATED} testId="data-deletion">
      <p className="mt-6">
        This page explains how to delete data held by DentMemo, operated by {COMPANY.name}. For what we collect and why, see
        our <Link to="/privacy" className="font-semibold text-slate-900 underline underline-offset-2">Privacy Policy</Link>.
      </p>

      <Part title="Delete all of your clinic’s data">
        <p>The clinic owner can permanently erase the clinic’s data from inside the app:</p>
        <ol className="list-decimal space-y-2 pl-5">
          <li>Sign in to DentMemo as the clinic owner.</li>
          <li>Open <span className="font-semibold text-slate-800">Settings</span>.</li>
          <li>Optional: download a backup first with <span className="font-semibold text-slate-800">Download JSON</span>.</li>
          <li>In the <span className="font-semibold text-slate-800">Danger zone</span>, choose <span className="font-semibold text-slate-800">Delete all clinic data</span> and confirm.</li>
        </ol>
        <p>
          This immediately and permanently deletes the clinic’s patient records, visits, appointments, consultants, settlements, reminder
          logs, stored backups, and the photos and X-rays attached to visits. It cannot be undone.
        </p>
      </Part>

      <Part title="Close your account completely">
        <p>
          To delete your user account itself (your name, email address, mobile number and sign-in details), or your whole clinic account,
          email <Mail /> from the email address you sign in with and ask us to close the account. We will confirm the request and
          complete it within 30 days, except for information the law requires us to keep, such as payment and tax records.
        </p>
      </Part>

      <Part title="Other deletion">
        <List items={[
          ["Staff members:", "ask your clinic owner to remove you, or email us to delete your account."],
          ["Patients:", "your records belong to your clinic. Please ask your clinic to delete them; we will help the clinic respond."],
          ["Sign in with Google:", "you can also remove DentMemo’s access at any time from your Google Account’s security settings. To delete the data we received from Google, email us as above."],
          ["Copies on your devices:", "DentMemo keeps an offline copy of records in the browser. Sign out and clear the browser’s site data for dentmemo.in to remove it from a device."],
        ]} />
      </Part>

      <Part title="Contact">
        <p>Questions about deletion: <Mail /> or <Phone />, or write to {COMPANY.name}, {COMPANY.address}.</p>
      </Part>
    </LegalPage>
  );
}
